var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { getTemplate, getUiOptions, } from '@rjsf/utils';
import { Grid, Stack } from '@mui/material';
export var ArrayFieldTemplate = function (_a) {
    var title = _a.title, required = _a.required, disabled = _a.disabled, readonly = _a.readonly, uiSchema = _a.uiSchema, idSchema = _a.idSchema, schema = _a.schema, onAddClick = _a.onAddClick, registry = _a.registry, items = _a.items, canAdd = _a.canAdd;
    var uiOptions = getUiOptions(uiSchema);
    var ArrayFieldDescriptionTemplate = getTemplate('ArrayFieldDescriptionTemplate', registry, uiOptions);
    var ArrayFieldItemTemplate = getTemplate('ArrayFieldItemTemplate', registry, uiOptions);
    var ArrayFieldTitleTemplate = getTemplate('ArrayFieldTitleTemplate', registry, uiOptions);
    var AddButton = registry.templates.ButtonTemplates.AddButton;
    return (React.createElement(React.Fragment, null,
        (uiSchema['ui:title'] || title) && (React.createElement(ArrayFieldTitleTemplate, { idSchema: idSchema, title: title, required: required, schema: schema, registry: registry })),
        React.createElement(Stack, { spacing: 1 },
            items &&
                items.map(function (_a) {
                    var key = _a.key, itemProps = __rest(_a, ["key"]);
                    return (React.createElement(ArrayFieldItemTemplate, __assign({ key: key }, itemProps)));
                }),
            canAdd && (React.createElement(Grid, { container: true, justifyContent: "flex-end" },
                React.createElement(Grid, { item: true },
                    React.createElement(AddButton, { registry: registry, className: "object-property-expand", onClick: onAddClick, disabled: disabled || readonly }))))),
        React.createElement(ArrayFieldDescriptionTemplate, { idSchema: idSchema, schema: schema, registry: registry })));
};
export default ArrayFieldTemplate;
